<template>
  <div class="pc_brand-tab">
    <div class="brand-main">
      <div class="brand-title">
        <div class="title-div">{{ $t("PCBrandTab.index") }}:</div>
      </div>
      <PC-scroll-tab
        :list="brandList"
        :active="active"
        @handleSetActive="onTab" />
    </div>
  </div>
</template>

<script>
// import PCScrollTab from '@/components/PCScrollTab'
import PCScrollTab from '@/components/PCScrollTab/index2.vue'
export default {
  name: 'PCBrandTab',
  components: {
    PCScrollTab
  },
  props: {
    brandList: Array
  },
  data() {
    return {
      active: 0
    };
  },
  methods: {
    onTab(item) {
      const { brandId, index } = item;
      this.active = index;
      this.$emit("onChange", brandId);
    }
  },
  computed: {
    brandData() {
      return this.brandList;
    }
  }
};
</script>

<style scoped lang="less">
.pc_brand-tab {
  background-color: #fff;
  // height: 72px;
  border-radius:  0 0 8px 8px;
  overflow: hidden;
  .brand-main {
    width: 100%;
    height: 100%;
    display: flex;
    .brand-title {
      width: 165px;
      padding: 25px 0px 25px 40px;
    }
    .title-div {
      color: #6E6E6E;
      font-size: 16px;
    }
    .brand-right {
      flex: 1;
      display: flex;
    }
  }
}
</style>
